import { TypographyVariant, TypographyStyle } from '../core';

export type TypographyScale = Record<TypographyVariant, TypographyStyle>;

export const typographyScaleDesktop: TypographyScale = {
  d1: {
    fontSize: '74px',
    lineHeight: '84px',
    fontWeight: 600,
    fontFamily: 'Inter-SemiBold',
  },
  d2: {
    fontSize: '54px',
    lineHeight: '64px',
    fontWeight: 600,
    fontFamily: 'Inter-SemiBold',
  },
  h1: {
    fontSize: '40px',
    lineHeight: '54px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h2: {
    fontSize: '36px',
    lineHeight: '48px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h3: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h4: {
    fontSize: '28px',
    lineHeight: '38px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h5: {
    fontSize: '24px',
    lineHeight: '36px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h6: {
    fontSize: '20px',
    lineHeight: '34px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h7: {
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  p1: {
    fontSize: '16px',
    lineHeight: '28px',
    fontWeight: 400,
    fontFamily: 'Inter-Regular',
  },
  p2: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    fontFamily: 'Inter-Regular',
  },
  p3: {
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 400,
    fontFamily: 'Inter-Regular',
  },
};

export const typographyScaleMobile: TypographyScale = {
  d1: {
    fontSize: '40px',
    lineHeight: '54px',
    fontWeight: 600,
    fontFamily: 'Inter-SemiBold',
  },
  d2: {
    fontSize: '36px',
    lineHeight: '48px',
    fontWeight: 600,
    fontFamily: 'Inter-SemiBold',
  },
  h1: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h2: {
    fontSize: '28px',
    lineHeight: '38px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h3: {
    fontSize: '24px',
    lineHeight: '36px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h4: {
    fontSize: '22px',
    lineHeight: '34px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h5: {
    fontSize: '20px',
    lineHeight: '34px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h6: {
    fontSize: '18px',
    lineHeight: '30px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  h7: {
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 500,
    fontFamily: 'Inter-Medium',
  },
  p1: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    fontFamily: 'Inter-Regular',
  },
  p2: {
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 400,
    fontFamily: 'Inter-Regular',
  },
  p3: {
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 400,
    fontFamily: 'Inter-Regular',
  },
};
